import type { FunctionComponent, Ref } from 'react'
import React from 'react'
import { createPath } from 'history'

import { useRouter } from './RouterContext'
import type { LocationInit, LocationState } from './types'

export type LinkRef = HTMLAnchorElement

export interface LinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: string | LocationInit
  replace?: boolean
  state?: LocationState
  ref?: Ref<LinkRef>
}

export const Link: FunctionComponent<LinkProps> = ({ to, onClick, replace, state, children, ref, ...props }) => {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (onClick) onClick(e)
    if (props.target === '_blank') return
    if (e.defaultPrevented) return
    e.preventDefault()
    if (replace) {
      router.history.replace(to, state)
    } else {
      router.history.push(to, state)
    }
  }

  const href = typeof to === 'string' ? to : createPath(to)

  return (
    <a href={href} onClick={handleClick} ref={ref} {...props}>
      {children}
    </a>
  )
}
